import { IProductInfoAllergen } from '@/shared/model/product-info-allergen.model';
import { IAddonCategory } from '@/shared/model/addon-category.model';
import { IAvailability } from '@/shared/model/availability.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IMenuCategory } from '@/shared/model/menu-category.model';
import { IMenuVariant } from '@/shared/model/menu-variant.model';
import { IMenu } from '@/shared/model/menu.model';
import { IMultiLanguage } from '@/shared/model/multi-language.model';
import { IRestaurant } from '@/shared/model/restaurant.model';
import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { MenusManagementType } from './types';
import { IProductInfoAdditive } from '@/shared/model/product-info-additive.model';

export const getters: GetterTree<MenusManagementType, RootState> = {
  getMenuCategoriesTab(state): number {
    return state.menuCategoriesTab;
  },
  getMenusTab(state): number[] {
    return state.menusTab;
  },
  getStepper(state): number {
    return state.stepper;
  },
  getMenuCategories(state): IMenuCategory[] {
    return state.menuCategories;
  },
  getAllergens(state): IProductInfoAllergen[] {
    return state.allergens;
  },
  getAdditives(state): IProductInfoAdditive[] {
    return state.additives;
  },
  getEnabled(state): boolean {
    return state.menuCategories[state.menuCategoriesTab]?.enabled;
  },
  getNonfood(state): boolean {
    return state.menuCategories[state.menuCategoriesTab]?.nonfood;
  },
  getTitle(state): IMultiLanguage {
    return state.menuCategories[state.menuCategoriesTab].title;
  },
  getDescription(state): IMultiLanguage {
    return state.menuCategories[state.menuCategoriesTab].description;
  },
  getDiscount(state): IDiscount {
    return state.menuCategories[state.menuCategoriesTab].discount;
  },
  getMenus(state): IMenu[] {
    return state.menuCategories[state.menuCategoriesTab].menus;
  },
  getMenuVariants(state): IMenuVariant[] {
    if (
      !state.menuCategories[state.menuCategoriesTab].menus ||
      !state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]]
    ) {
      return [];
    }
    return state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants;
  },
  getSortedMenuVariants(state): IMenuVariant[] {
    if (
      !state.menuCategories[state.menuCategoriesTab].menus ||
      !state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]]
    ) {
      return [];
    }
    return state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants.sort(
      (a, b) => a.ordinal - b.ordinal
    );
  },
  getMenuAddonCategories(state): IAddonCategory[] {
    if (
      !state.menuCategories[state.menuCategoriesTab].menus ||
      !state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]] ||
      !state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
    ) {
      return [];
    }
    return state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
      .addonCategories;
  },
  getSortedMenuAddonCategories(state): IAddonCategory[] {
    if (
      !state.menuCategories[state.menuCategoriesTab].menus ||
      !state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]] ||
      !state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
    ) {
      return [];
    }
    return state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[
      state.stepper
    ].addonCategories.sort((a, b) => a.ordinal - b.ordinal);
  },
  getMenuCategoryAvailabilities(state): IAvailability[] {
    return state.menuCategories[state.menuCategoriesTab].availabilities;
  },
  getMenuVariantAvailabilities(state): IAvailability[] {
    if (
      !state.menuCategories[state.menuCategoriesTab].menus ||
      !state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]] ||
      !state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
    ) {
      return [];
    }
    return state.menuCategories[state.menuCategoriesTab].menus[state.menusTab[state.menuCategoriesTab]].menuVariants[state.stepper]
      .availabilities;
  },
  getRestaurant(state): IRestaurant {
    return state.menuCategories[state.menuCategoriesTab].restaurant;
  },
};
